"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _mapInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/map");

var _reduceInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/reduce");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.errorReducer = exports.endReducer = exports.startReducer = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _m = require("@mutant-ws/m");

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; (0, _forEach.default)(_context = ownKeys(Object(source), true)).call(_context, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context2; (0, _forEach.default)(_context2 = ownKeys(Object(source))).call(_context2, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

var debug = require("debug")("ReduxList:ReadReducers");

var startReducer = function startReducer(state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: true
  });
};

exports.startReducer = startReducer;

var endReducer = function endReducer(state, _ref) {
  var _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      shouldClear = _ref.shouldClear,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? _m.i : _ref$onChange;
  return _objectSpread(_objectSpread({}, state), {}, {
    items: (0, _m.pipe)((0, _m.when)(function () {
      return shouldClear === true;
    }, (0, _m.same)(items), (0, _reduceInstanceProperty(_m))(function () {
      var acc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : state.items;
      var accItem = arguments.length > 1 ? arguments[1] : undefined;
      return (0, _m.when)((0, _m.hasWith)({
        id: accItem.id
      }), (0, _mapInstanceProperty(_m))(function (mapItem) {
        return mapItem.id === accItem.id ? (0, _m.merge)(mapItem, accItem) : mapItem;
      }), (0, _m.push)(accItem))(acc);
    })), onChange)(items),
    // reset error after successfull action
    errors: _objectSpread(_objectSpread({}, state.errors), {}, {
      read: null
    }),
    loadDate: new Date(),
    isLoading: false
  });
};

exports.endReducer = endReducer;

var errorReducer = function errorReducer(state, error) {
  return _objectSpread(_objectSpread({}, state), {}, {
    errors: _objectSpread(_objectSpread({}, state.errors), {}, {
      read: error
    }),
    items: [],
    isLoading: false
  });
};

exports.errorReducer = errorReducer;